import addComment from 'root/src/client/logic/comment/actions/addComment'

export default ({ body }) => (dispatch) => {
	dispatch(addComment(body))
}
